import React, { useState, useEffect } from 'react';

const Countries = () => {
  const [activeCountry, setActiveCountry] = useState('kenya');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const countryData = {
    kenya: {
      flag: "🇰🇪",
      name: "Kenya",
      activationFee: "Ksh 500",
      welcomeBonus: "Ksh 100",
      commissions: [
        { level: "Level 1", amount: "Ksh 300", color: "from-green-500 to-emerald-500" },
        { level: "Level 2", amount: "Ksh 100", color: "from-blue-500 to-cyan-500" },
        { level: "Level 3", amount: "Ksh 50", color: "from-purple-500 to-pink-500" }
      ],
      methods: [
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia questions",
        "Selling data and airtime",
        "Follower gains",
        "Tournaments",
        "Advanced Forex signals"
      ],
      currency: "Ksh",
      color: "from-green-500 to-emerald-500"
    },
    international: {
      flag: "🌐",
      name: "International",
      activationFee: "USD 10",
      welcomeBonus: "USD 1.5",
      commissions: [
        { level: "Level 1", amount: "USD 3.5", color: "from-blue-500 to-cyan-500" },
        { level: "Level 2", amount: "USD 1.5", color: "from-purple-500 to-pink-500" },
        { level: "Level 3", amount: "USD 0.76", color: "from-yellow-500 to-amber-500" }
      ],
      methods: [
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia questions",
        "Selling data and airtime",
        "Follower gains",
        "Tournaments",
        "Advanced Forex signals"
      ],
      currency: "USD",
      color: "from-blue-500 to-cyan-500"
    },
    ghana: {
      flag: "🇬🇭",
      name: "Ghana",
      activationFee: "GHC 80",
      welcomeBonus: "GHC 15",
      commissions: [
        { level: "Level 1", amount: "GHC 35", color: "from-yellow-500 to-amber-500" },
        { level: "Level 2", amount: "GHC 15", color: "from-red-500 to-pink-500" },
        { level: "Level 3", amount: "GHC 10", color: "from-green-500 to-emerald-500" }
      ],
      methods: [
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia questions",
        "Selling data and airtime",
        "Follower gains",
        "Tournaments",
        "Advanced Forex signals"
      ],
      currency: "GHC",
      color: "from-yellow-500 to-amber-500"
    },
    uganda: {
      flag: "🇺🇬",
      name: "Uganda",
      activationFee: "UGX 19,000",
      welcomeBonus: "UGX 5,500",
      commissions: [
        { level: "Level 1", amount: "UGX 8,000", color: "from-purple-500 to-pink-500" },
        { level: "Level 2", amount: "UGX 5,500", color: "from-yellow-500 to-amber-500" },
        { level: "Level 3", amount: "UGX 2,000", color: "from-blue-500 to-cyan-500" }
      ],
      methods: [
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia questions",
        "Selling data and airtime",
        "Follower gains",
        "Tournaments",
        "Advanced Forex signals"
      ],
      currency: "UGX",
      color: "from-purple-500 to-pink-500"
    },
    nigeria: {
      flag: "🇳🇬",
      name: "Nigeria",
      activationFee: "NGN 15,000",
      welcomeBonus: "NGN 2,500",
      commissions: [
        { level: "Level 1", amount: "NGN 7,000", color: "from-green-500 to-emerald-500" },
        { level: "Level 2", amount: "NGN 2,500", color: "from-white to-gray-300" },
        { level: "Level 3", amount: "NGN 1,000", color: "from-yellow-500 to-amber-500" }
      ],
      methods: [
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia questions",
        "Selling data and airtime",
        "Follower gains",
        "Tournaments",
        "Advanced Forex signals"
      ],
      currency: "NGN",
      color: "from-green-500 to-emerald-500"
    },
    malawi: {
      flag: "🇲🇼",
      name: "Malawi",
      activationFee: "MK 20,500",
      welcomeBonus: "MK 2,500",
      commissions: [
        { level: "Level 1", amount: "MK 6,000", color: "from-red-500 to-pink-500" },
        { level: "Level 2", amount: "MK 2,500", color: "from-black to-gray-800" },
        { level: "Level 3", amount: "MK 1,000", color: "from-green-500 to-emerald-500" }
      ],
      methods: [
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia questions",
        "Selling data and airtime",
        "Follower gains",
        "Tournaments",
        "Advanced Forex signals",
        "Data deal plans/airtime",
        "Bonus earning opportunities"
      ],
      currency: "MK",
      color: "from-red-500 to-pink-500"
    },
    tanzania: {
      flag: "🇹🇿",
      name: "Tanzania",
      activationFee: "TZS 12,500",
      welcomeBonus: "TZS 2,500",
      commissions: [
        { level: "Level 1", amount: "TZS 5,000", color: "from-blue-500 to-cyan-500" },
        { level: "Level 2", amount: "TZS 2,500", color: "from-yellow-500 to-amber-500" },
        { level: "Level 3", amount: "TZS 1,000", color: "from-green-500 to-emerald-500" }
      ],
      methods: [
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia questions",
        "Selling data and airtime",
        "Follower gains",
        "Tournaments",
        "Advanced Forex signals"
      ],
      currency: "TZS",
      color: "from-blue-500 to-cyan-500"
    },
    zambia: {
      flag: "🇿🇲",
      name: "Zambia",
      activationFee: "ZK 115",
      welcomeBonus: "ZK 25",
      commissions: [
        { level: "Level 1", amount: "ZK 55", color: "from-green-500 to-emerald-500" },
        { level: "Level 2", amount: "ZK 25", color: "from-red-500 to-pink-500" },
        { level: "Level 3", amount: "ZK 10", color: "from-orange-500 to-amber-500" }
      ],
      methods: [
        "Welcome Bonus - ZK 25",
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia Questions",
        "Selling data and airtime",
        "Follower Gains",
        "Tournaments",
        "Automatic activations",
        "Instant withdrawals"
      ],
      advantages: [
        "24/7 customer service",
        "Multiple income streams",
        "Flexible working hours"
      ],
      currency: "ZK",
      color: "from-green-500 to-emerald-500"
    },
    botswana: {
      flag: "🇧🇼",
      name: "Botswana",
      activationFee: "90 PULA",
      welcomeBonus: "15 PULA",
      commissions: [
        { level: "Level 1", amount: "35 PULA", color: "from-blue-500 to-cyan-500" },
        { level: "Level 2", amount: "15 PULA", color: "from-black to-gray-800" },
        { level: "Level 3", amount: "10 PULA", color: "from-white to-gray-300" }
      ],
      methods: [
        "Welcome Bonus - 15 PULA",
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia Questions",
        "Selling data and airtime",
        "Follower Gains",
        "Tournaments",
        "Automatic activations",
        "Instant withdrawals"
      ],
      advantages: [
        "24/7 customer service",
        "Multiple income streams",
        "Flexible working hours"
      ],
      currency: "PULA",
      color: "from-blue-500 to-cyan-500"
    },
    rwanda: {
      flag: "🇷🇼",
      name: "Rwanda",
      activationFee: "RF 6,000",
      welcomeBonus: "RF 1,250",
      commissions: [
        { level: "Level 1", amount: "RF 2,850", color: "from-blue-500 to-cyan-500" },
        { level: "Level 2", amount: "RF 1,250", color: "from-yellow-500 to-amber-500" },
        { level: "Level 3", amount: "RF 500", color: "from-green-500 to-emerald-500" }
      ],
      methods: [
        "Welcome Bonus - RF 1,250",
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia Questions",
        "Selling data and airtime",
        "Follower Gains",
        "Tournaments",
        "Automatic activations",
        "Instant withdrawals"
      ],
      advantages: [
        "24/7 customer service",
        "Multiple income streams",
        "Flexible working hours"
      ],
      currency: "RF",
      color: "from-blue-500 to-cyan-500"
    },
    southafrica: {
      flag: "🇿🇦",
      name: "South Africa",
      activationFee: "R 180",
      welcomeBonus: "R 28",
      commissions: [
        { level: "Level 1", amount: "R 65", color: "from-green-500 to-emerald-500" },
        { level: "Level 2", amount: "R 28", color: "from-yellow-500 to-amber-500" },
        { level: "Level 3", amount: "R 14", color: "from-red-500 to-pink-500" }
      ],
      methods: [
        "Welcome Bonus - R 28",
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia Questions",
        "Selling data and airtime",
        "Follower Gains",
        "Tournaments",
        "Advanced Forex signals",
        "Data deal plans/airtime"
      ],
      advantages: [
        "24/7 customer service",
        "Automatic activations",
        "Instant withdrawals"
      ],
      currency: "R",
      color: "from-green-500 to-emerald-500"
    },
    cameroon: {
      flag: "🇨🇲",
      name: "Cameroon",
      activationFee: "XAF 3,100",
      welcomeBonus: "XAF 550",
      commissions: [
        { level: "Level 1", amount: "XAF 1,500", color: "from-green-500 to-emerald-500" },
        { level: "Level 2", amount: "XAF 550", color: "from-red-500 to-pink-500" },
        { level: "Level 3", amount: "XAF 300", color: "from-yellow-500 to-amber-500" }
      ],
      methods: [
        "Welcome Bonus - XAF 550",
        "Watching YouTube videos",
        "Watching TikTok videos",
        "Netflix ads",
        "Trivia Questions",
        "Selling data and airtime",
        "Follower Gains",
        "Tournaments",
        "Advanced Forex signals",
        "Data deal plans/airtime"
      ],
      advantages: [
        "Automatic activations",
        "24/7 customer support",
        "Weekly agent ranking & rewards",
        "Forex training for beginners",
        "Demo & live trading accounts"
      ],
      currency: "XAF",
      status: "Launching Soon",
      color: "from-green-500 to-emerald-500"
    }
  };

  const country = countryData[activeCountry];

  return (
    <section className="countries py-20 md:py-32 bg-gradient-to-br from-slate-50 via-white to-blue-50/30 relative overflow-hidden" id="countries">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-500/5 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Header Section */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center space-x-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-3 rounded-full text-sm font-bold mb-6 shadow-lg shadow-blue-500/25">
            <span className="h-2 w-2 bg-white rounded-full animate-pulse"></span>
            <span>GLOBAL EARNINGS</span>
            <span className="h-2 w-2 bg-white rounded-full animate-pulse animation-delay-1000"></span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-gray-800 via-blue-600 to-purple-600 bg-clip-text text-transparent">
            Tailored for Your
            <span className="block text-transparent bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text"> Location</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            VumaQash offers customized earning potential based on your country. Select your location to see specific opportunities.
          </p>
        </div>

        {/* Country Selector - Enhanced */}
        <div className="flex flex-wrap justify-center gap-3 mb-16">
          {Object.entries(countryData).map(([countryKey, data]) => (
            <button
              key={countryKey}
              className={`group relative px-6 py-4 rounded-2xl transition-all duration-500 transform hover:scale-105 ${
                activeCountry === countryKey
                  ? `bg-gradient-to-r ${data.color} text-white shadow-2xl scale-105`
                  : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 hover:border-gray-300 shadow-lg'
              }`}
              onClick={() => setActiveCountry(countryKey)}
            >
              <span className="text-2xl mr-3">{data.flag}</span>
              <span className="font-semibold">{data.name}</span>
              
              {/* Active Indicator */}
              {activeCountry === countryKey && (
                <div className="absolute -top-2 -right-2 w-4 h-4 bg-white rounded-full animate-ping"></div>
              )}
              
              {/* Hover Effect */}
              <div className={`absolute inset-0 bg-gradient-to-r ${data.color} rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
            </button>
          ))}
        </div>

        {/* Main Content Card */}
        <div className={`transform transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
        }`}>
          <div className="bg-gradient-to-br from-white to-gray-50/80 backdrop-blur-sm rounded-3xl shadow-2xl border border-gray-200/50 overflow-hidden">
            {/* Country Header */}
            <div className={`bg-gradient-to-r ${country.color} p-8 text-white relative overflow-hidden`}>
              {/* Background Pattern */}
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white/10 via-transparent to-white/5"></div>
              
              <div className="relative z-10 flex flex-col lg:flex-row justify-between items-start lg:items-center">
                <div className="flex items-center mb-6 lg:mb-0">
                  <span className="text-6xl mr-6 drop-shadow-lg">{country.flag}</span>
                  <div>
                    <h3 className="text-3xl md:text-4xl font-bold mb-2 drop-shadow-lg">{country.name} Earnings</h3>
                    <p className="text-white/90 text-lg">Customized opportunities for {country.name} residents</p>
                    {country.status && (
                      <span className="bg-white/20 backdrop-blur-sm text-white px-4 py-1 rounded-full text-sm font-medium mt-3 inline-block">
                        🚀 {country.status}
                      </span>
                    )}
                  </div>
                </div>
                
                <a
                  href={`https://wa.me/254115647545?text=Hey%20Cleophas,%20I'm%20from%20${country.name}%20and%20need%20guidance%20on%20VumaQash`}
                  className="group bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-bold py-4 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center space-x-3"
                >
                  <span className="text-xl">💬</span>
                  <span>Get {country.name} Guide</span>
                  <span className="group-hover:translate-x-1 transition-transform">→</span>
                </a>
              </div>
            </div>

            {/* Content Grid */}
            <div className="p-8">
              {/* Quick Stats */}
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl border border-blue-200 transform transition-all duration-500 hover:scale-105 group">
                  <h4 className="text-xl font-bold mb-6 text-gray-800 flex items-center">
                    <span className="w-3 h-3 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full mr-3 animate-pulse"></span>
                    Activation Details
                  </h4>
                  <div className="space-y-4">
                    <div className="flex justify-between items-center p-4 bg-white rounded-xl border border-blue-100">
                      <span className="text-gray-600 font-medium">One-time Fee:</span>
                      <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
                        {country.activationFee}
                      </span>
                    </div>
                    <div className="flex justify-between items-center p-4 bg-white rounded-xl border border-green-100">
                      <span className="text-gray-600 font-medium">Welcome Bonus:</span>
                      <span className="text-2xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
                        {country.welcomeBonus}
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-8 rounded-2xl border border-purple-200 transform transition-all duration-500 hover:scale-105 group">
                  <h4 className="text-xl font-bold mb-6 text-gray-800 flex items-center">
                    <span className="w-3 h-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mr-3 animate-pulse"></span>
                    Quick Start Guide
                  </h4>
                  <div className="space-y-4">
                    {[
                      "Pay one-time activation fee",
                      "Receive welcome bonus instantly", 
                      "Start exploring 10+ income streams"
                    ].map((step, index) => (
                      <div key={index} className="flex items-center space-x-4 p-3 bg-white/80 rounded-xl">
                        <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                          {index + 1}
                        </div>
                        <span className="text-gray-700 font-medium">{step}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Affiliate Commissions */}
              <div className="mb-12">
                <h4 className="text-2xl font-bold mb-8 text-gray-800 text-center">Affiliate Program Commissions</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {country.commissions.map((commission, index) => (
                    <div key={index} className="group transform transition-all duration-500 hover:scale-105">
                      <div className={`bg-gradient-to-br ${commission.color} p-8 rounded-2xl text-center text-white shadow-2xl relative overflow-hidden`}>
                        {/* Shine Effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                        
                        <h5 className="text-lg font-semibold mb-4 opacity-90">{commission.level}</h5>
                        <div className="text-3xl font-bold mb-2 drop-shadow-lg">{commission.amount}</div>
                        <p className="opacity-90">Per direct referral</p>
                        
                        {/* Floating Element */}
                        <div className="absolute -top-2 -right-2 w-6 h-6 bg-white/30 rounded-full blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-float"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Earning Methods */}
              <div className="mb-12">
                <h4 className="text-2xl font-bold mb-8 text-gray-800 text-center">All Earning Methods</h4>
                <div className="grid md:grid-cols-2 gap-8">
                  <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 transform transition-all duration-500 hover:scale-105">
                    <h5 className="text-xl font-bold mb-6 text-gray-800 flex items-center">
                      <span className="text-2xl mr-3">🎬</span>
                      Content Engagement
                    </h5>
                    <div className="grid gap-3">
                      {country.methods.slice(0, Math.ceil(country.methods.length / 2)).map((method, index) => (
                        <div key={index} className="flex items-center space-x-3 p-3 bg-white rounded-xl border border-gray-100 group hover:border-blue-200 transition-all duration-300">
                          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full flex items-center justify-center text-white text-sm">
                            ✓
                          </div>
                          <span className="text-gray-700 font-medium group-hover:text-blue-600 transition-colors duration-300">{method}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 transform transition-all duration-500 hover:scale-105">
                    <h5 className="text-xl font-bold mb-6 text-gray-800 flex items-center">
                      <span className="text-2xl mr-3">💎</span>
                      Additional Streams
                    </h5>
                    <div className="grid gap-3">
                      {country.methods.slice(Math.ceil(country.methods.length / 2)).map((method, index) => (
                        <div key={index} className="flex items-center space-x-3 p-3 bg-white rounded-xl border border-gray-100 group hover:border-purple-200 transition-all duration-300">
                          <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white text-sm">
                            ✓
                          </div>
                          <span className="text-gray-700 font-medium group-hover:text-purple-600 transition-colors duration-300">{method}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Additional Advantages */}
              {country.advantages && (
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-8 rounded-2xl border border-green-200 mb-12 transform transition-all duration-500 hover:scale-105">
                  <h4 className="text-xl font-bold mb-6 text-gray-800 flex items-center">
                    <span className="text-2xl mr-3">⭐</span>
                    Added Advantages
                  </h4>
                  <div className="grid md:grid-cols-2 gap-4">
                    {country.advantages.map((advantage, index) => (
                      <div key={index} className="flex items-center space-x-3 p-4 bg-white rounded-xl border border-green-100 group hover:border-green-200 transition-all duration-300">
                        <div className="w-6 h-6 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center text-white text-xs">
                          +
                        </div>
                        <span className="text-gray-700 font-medium group-hover:text-green-600 transition-colors duration-300">{advantage}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Footer CTA */}
            <div className={`bg-gradient-to-r ${country.color} p-12 text-white text-center relative overflow-hidden`}>
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white/10 via-transparent to-white/5"></div>
              <div className="relative z-10">
                <h4 className="text-3xl font-bold mb-4 drop-shadow-lg">Ready to Start Earning in {country.name}?</h4>
                <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
                  Join thousands of members in {country.name} who are already building their financial freedom with VumaQash
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                  <a
                    href={`https://wa.me/254115647545?text=Hey%20Cleophas,%20I'm%20from%20${country.name}%20and%20ready%20to%20join%20VumaQash`}
                    className="group bg-white text-gray-800 font-bold py-4 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-2xl hover:shadow-white/25 flex items-center space-x-3"
                  >
                    <span className="text-xl">💬</span>
                    <span>Start Earning in {country.name}</span>
                    <span className="group-hover:translate-x-1 transition-transform">→</span>
                  </a>
                  
                  <a
                    href="https://t.me/CLEOPHAS_MWK"
                    className="group bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-bold py-4 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center space-x-3"
                  >
                    <span className="text-xl">⚡</span>
                    <span>Fast Activation</span>
                    <span className="group-hover:translate-x-1 transition-transform">→</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add custom animations */}
        <style jsx>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-5px); }
          }
          .animate-float {
            animation: float 3s ease-in-out infinite;
          }
          .animation-delay-1000 {
            animation-delay: 1000ms;
          }
        `}</style>
      </div>
    </section>
  );
};

export default Countries;